import React, { useEffect } from 'react';
import Header from './partials/header';
import Footer from './partials/footer';
import Alerter from "@/layouts/partials/alerter";
import PurchaseModal from "@/layouts/partials/purchase-modal";
import GlobalPlayer from "@/layouts/partials/global-player";
import FullPageLoader from "@/layouts/partials/fullpage-loader";
import { isMobileApp } from '@/app/general';
import { useSelector } from 'react-redux';

type Props = {
  title?: string,
  children?: JSX.Element[] | JSX.Element
};

const Guest: React.FC<Props> = (props) => {
    const user = useSelector((state: any) => state.auth.user);

    const acceptedRoutes = [
        '/login',
        '/logout',
        '/register',
        '/password/reset',
        '/terms'
    ];
    if(isMobileApp() && !user && !acceptedRoutes.some(ar => ar === document.location.pathname)) {
        document.location.href = '/login';
        return null;
    }

    return (
        <div id="wrapper">
            <Header />
            <div id="content">
                {props.children}
            </div>
            <Footer />
            <Alerter />
            <GlobalPlayer />
            <FullPageLoader />
            <PurchaseModal />
        </div>
    );
}

export default Guest;
